const weekFormatter = (week: number) => {
    const weekDate = new Date(week * 1000);
    const date = weekDate.getDate();
    const month = weekDate.getMonth() + 1;
    return (date < 10 ? '0' +  date : date) + '-' + (month < 10 ? '0' +  month : month);
};

export default weekFormatter;